import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { TopNavigation } from '@/components/layout/TopNavigation';
import { ConnectionsTab } from '@/components/connections/ConnectionsTab';
import { UserConnectionsList } from '@/components/connections/UserConnectionsList';
import { useMyConnections } from '@/shared/hooks/useMyConnections';
import { useI18n } from '@/contexts/I18nContext';

interface UserConnectionsProps {
  userId: string;
  isOwnProfile: boolean;
}

export const UserConnections: React.FC<UserConnectionsProps> = ({ userId, isOwnProfile }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { data: connectionsData, refetch, hasNextPage, isFetchingNextPage, fetchNextPage } = useMyConnections();
  const connections = connectionsData?.pages?.flat() || [];
  const { t } = useI18n();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <TopNavigation variant="subtle" />
      <div className="min-h-screen bg-[#160C0C] text-white">
        
        {/* Header */}
        <div className="pt-16">
          <div className="relative flex items-center px-4 py-3.5 border-b border-[#281B1B]">
            <button onClick={handleBack} className="p-1 text-white/80 hover:text-white transition-colors">
              <ArrowLeft className="w-5 h-5" />
            </button>
            <h1 className="absolute left-1/2 -translate-x-1/2 text-base font-semibold truncate max-w-[60%]">{t('profile.connections')}</h1>
          </div>

          {/* Content */}
          <div className="p-4">
            {isOwnProfile ? (
              <ConnectionsTab 
                connections={connections} 
                refetchConnections={async () => { await refetch(); }}
                hasNextPage={hasNextPage}
                isFetchingNextPage={isFetchingNextPage}
                fetchNextPage={fetchNextPage}
                noContainer={true} 
              />
            ) : (
              <UserConnectionsList userId={userId} />
            )}
          </div>
        </div>
      </div>
    </>
  );
}; 